import React from 'react'
import Tabs from '~/app/components/common/Tabs/Tabs'

/**
 * CartTabs component
 * author: jaegeunlee
 * description
 */
export enum Category {
  ALL = 'ALL',
  ACCOMMODATION = 'ACCOMMODATION',
  TICKET = 'TICKET',
  TRAIN = 'TRAIN',
  BUS = 'BUS',
}

export enum CategoryGroup {
  ALL = 'ALL',
  ACCOMMODATION = 'ACCOMMODATION',
  TICKET = 'TICKET',
  TRANSPORTATION = 'TRANSPORTATION',
}

interface CartTabsProps {
  currentTab: CategoryGroup
  totalCount: number
  accommodationCount: number
  ticketCount: number
  trainCount: number
  busCount: number
  rentACarCount: number
  onChangeTab?: (tab: CategoryGroup) => void
}
const CartTabs: React.FC<CartTabsProps> = ({
  currentTab,
  totalCount,
  accommodationCount,
  ticketCount,
  trainCount,
  busCount,
  rentACarCount,
  onChangeTab,
}) => {
  const tabs = [
    { label: `전체(${totalCount})`, value: CategoryGroup.ALL },
    {
      label: `국내숙소(${accommodationCount})`,
      value: CategoryGroup.ACCOMMODATION,
    },
    { label: `국내레저(${ticketCount})`, value: CategoryGroup.TICKET },
    {
      label: `교통(${trainCount + busCount + rentACarCount})`,
      value: CategoryGroup.TRANSPORTATION,
    },
  ]
  return (
    <Tabs
      tabs={tabs}
      currentTab={currentTab}
      onTabChangeHandler={val => onChangeTab?.(val as CategoryGroup)}
    />
  )
}

export default CartTabs
